export const blogCopyInput = {
    search_instructions: {
        url_count: "",
        brief: ""
    },
    reference_article_urls: {
        external: [""],
        dobin: [""]
    },
    reference_documents: {
        "pdfs": [""],
        "texts": [""]
    },
    seo_references: [""],
    article_instructions: {
        topic: "",
        content_outline: "",
        table_outline: "",
        writing_style: "",
        brief: "",
        dobin_context: "",
        dobin_feature: "",
        applicable_country: "",
        primary_keywords: [""],
        secondary_keywords: [""],
    },
    article_details: {
        domain: "",
        category: "",
    }
}


export const blogEntry = {
    title: "",
    page_title: "",
    url: "",
    description: "",
    read_duration: "2 mins read",
    category: "",
    countries: ["SG"],
    image_url: "",
    image_alt_text: ""
}